import styled from '@emotion/styled';
import { field } from '../Input/styles';

interface TextareaEmotionProps {
  rows?: number;
}

export const TextareaEmotion = styled('textarea')<TextareaEmotionProps>`
  ${field};
  overflow-y: auto;
  resize: vertical;
  box-sizing: content-box;
  height: ${props => (props.rows ? `${1.8 * props.rows}rem` : '18rem')};
  min-height: ${props => (props.rows ? `${1.8 * props.rows}rem` : '18rem')};
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  font-size: inherit;
`;
